import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";

const MarkdownAnswer = ({ text }: { text: string }) => (
  <div className="tw-text-label-md tw-leading-relaxed tw-text-[#25233D]">
    <Markdown
      remarkPlugins={[remarkGfm]}
      components={{
        h1: ({ children }) => <h3 className="tw-mb-2 tw-mt-4 tw-text-label-lg tw-font-semibold tw-text-[#1E1B4B] first:tw-mt-0">{children}</h3>,
        h2: ({ children }) => <h4 className="tw-mb-2 tw-mt-4 tw-text-label-md tw-font-semibold tw-text-[#1E1B4B] first:tw-mt-0">{children}</h4>,
        h3: ({ children }) => <h5 className="tw-mb-1.5 tw-mt-3 tw-text-label-md tw-font-semibold tw-text-[#1E1B4B] first:tw-mt-0">{children}</h5>,
        p: ({ children }) => <p className="tw-mb-3 last:tw-mb-0">{children}</p>,
        ul: ({ children }) => <ul className="tw-mb-3 tw-list-disc tw-space-y-1 tw-pl-5 last:tw-mb-0">{children}</ul>,
        ol: ({ children }) => <ol className="tw-mb-3 tw-list-decimal tw-space-y-1 tw-pl-5 last:tw-mb-0">{children}</ol>,
        strong: ({ children }) => <strong className="tw-font-semibold tw-text-[#1E1B4B]">{children}</strong>,
        code: ({ children }) => <code className="tw-rounded tw-bg-[#F4F3F9] tw-px-1 tw-py-0.5 tw-text-label-sm">{children}</code>,
        a: ({ href, children }) => (
          <a href={href} target="_blank" rel="noopener noreferrer" className="tw-text-[#4F46E5] tw-underline">
            {children}
          </a>
        ),
        table: ({ children }) => (
          <div className="tw-mb-3 tw-max-w-full tw-overflow-x-auto tw-rounded-lg tw-border tw-border-[#EAE8F5]">
            <table className="tw-w-full tw-border-collapse tw-text-label-sm">{children}</table>
          </div>
        ),
        thead: ({ children }) => <thead className="tw-bg-[#FAFAFD]">{children}</thead>,
        th: ({ children }) => <th className="tw-whitespace-nowrap tw-border-b tw-border-[#EAE8F5] tw-px-3 tw-py-2 tw-text-left tw-font-semibold tw-text-[#3D3950]">{children}</th>,
        td: ({ children }) => <td className="tw-border-b tw-border-[#F2F1F8] tw-px-3 tw-py-2 tw-align-top">{children}</td>,
      }}
    >
      {text}
    </Markdown>
  </div>
);

export default MarkdownAnswer;
